module.exports = __webpack_public_path__ + "img/popularize07.cb865a98.png";